require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/es7.symbol.observable.js
// module id = 308
// module chunks = 16